module.exports = __webpack_public_path__ + "img/long_button_on.98a18b76.png";